import { render } from "./Jobs.vue?vue&type=template&id=b5df960c"
import script from "./Jobs.vue?vue&type=script&lang=js"
export * from "./Jobs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__